import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { HOST } from "../../common/constant";
import axiosInstance from "../../common/interceptor";
import { toastOptions } from "../../common/Utils";
import "./AsphaltDashboard.css";

/**
 * 出荷キャンセル（SKY-53）: メイン表の「台目」セルのクリックで遷移し、対象の1台目の出荷をキャンセルする。
 * URL クエリ ?id=<トリップID> で対象を特定。
 */
interface IRow {
  id: number;
  terminalName?: string;
  daiMe?: number | null;
  state?: string;
  latestTemp?: number | null;
}

const t1 = (v?: number | null): string => (v === null || v === undefined ? "" : v.toFixed(1));

const CancelEdit: React.FC = () => {
  const id = new URLSearchParams(window.location.search).get("id");
  const [row, setRow] = useState<IRow | null>(null);

  const load = useCallback(() => {
    axiosInstance
      .get(HOST() + "/Form/V1/Dat/AsphaltDashboard/Board")
      .then((res) => {
        const rows = (res.data?.data?.rows as IRow[]) ?? [];
        setRow(rows.find((x) => String(x.id) === String(id)) ?? null);
      })
      .catch(() => toast.error("データの取得に失敗しました。", toastOptions));
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const back = () => (window.location.href = "/dashboard");

  const cancelShipment = () => {
    if (!row) return;
    if (!window.confirm("この台目の出荷をキャンセルしますか？")) return;
    axiosInstance
      .put(HOST() + "/Form/V1/Dat/AsphaltDashboard/Cancel", { id: row.id })
      .then(() => {
        toast.success("出荷をキャンセルしました。", toastOptions);
        back();
      })
      .catch(() => toast.error("失敗しました。", toastOptions));
  };

  const alreadyCancelled = row?.state === "キャンセル";

  return (
    <div className="asp-dashboard">
      <div style={{ maxWidth: "460px", margin: "0 auto" }}>
        <div className="asp-devhead">
          <div className="asp-title" style={{ flex: 1 }}>出荷キャンセル</div>
          <div>
            <button type="button" className="btn btn-primary btn-sm mar-5" onClick={back}>キャンセル</button>
          </div>
        </div>

        {row === null ? (
          <div className="asp-empty" style={{ padding: "20px 4px" }}>対象データがありません。</div>
        ) : (
          <div className="asp-loadedit">
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">台目</span>
              <span className="asp-loadedit-sep">：</span>
              <span>{row.daiMe ?? ""}</span>
            </div>
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">端末名</span>
              <span className="asp-loadedit-sep">：</span>
              <span>{row.terminalName}</span>
            </div>
            <div className="asp-loadedit-row">
              <span className="asp-loadedit-label">最新温度</span>
              <span className="asp-loadedit-sep">：</span>
              <span>{t1(row.latestTemp)}℃</span>
            </div>
            <div style={{ marginTop: "20px" }}>
              <button type="button" className="btn btn-primary" disabled={alreadyCancelled} onClick={cancelShipment}>
                出荷をキャンセルする
              </button>
              {alreadyCancelled && <span className="ml-2" style={{ color: "#6c757d", fontSize: "12px" }}>&nbsp;この台目は既にキャンセル済みです</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelEdit;
